/*
 *   File : summary.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Summary Card
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 08-11-2021
 */

/*import packages*/
import React from 'react';

/*Style Import*/
import styles from '../../styles/components/summary.module.scss';

const Summary = (props) => {

  return (
    <div className={`${styles.e_summary_card} card`}>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <h5>
            {props.data.title}
          </h5>
        </div>
      </div>
      <div className='row mt-auto'>
        <div className="col-lg-9 col-md-10 col-10 mt-3 pt-2">
          <span>
            <span className={styles.e_prefix}>{props.data.prefix}</span><span className={props.className}>{props.data.count}</span><span className={styles.e_text}>{props.data.text}</span></span>
        </div>
        <div className="col-lg-3 col-md-2 col-2 text-end">
          <div className="mt-3 card-image">
            <img src={props.data.icon} alt="" className={styles.e_summary_card_icon} />
          </div>
        </div>
      </div>

    </div>
  )
}

export default Summary